import * as THREE from 'three';
import EventDispatcher from "../common/EventDispatcher";
import {
    Global
} from "../common/global";
import gsap, {
    Linear
} from 'gsap';

export default class Keeper {
    constructor(scene) {
        this.scene = scene;
        this.onEvents = this.onEvents.bind(this);


    }

    init() {
        this.events = EventDispatcher.getObj();

        this.events.addEventListener("GAMESCENE_EVENTS", this.onEvents);
        this.events.addEventListener("PLAYER_EVENTS", this.onEvents);
        this.events.addEventListener("GAME_EVENTS", this.onEvents);

        this.mixer = null;
        this.mixer2 = null;
        this.mixer3 = null;
        this.shootStatus = null;
        this.lastPosition = new THREE.Vector3()
        this.isJumpInProgress = false
    }

    onEvents(data) {
        switch (data['message']['event_type']) {
            case "create_scene":
                this.addKeeper();
                break;
            case "update":
                this.update(data['message']['data']);
                break;
            case "assign_position":
                this.faceToBall(data['message']['data']);
                break;
            case "defend":
                this.defend(data['message']['data']);
                break;
            case "goal":
                this.showUnhappy();
                break;
            case "kick_ball":
                this.checkIfCanDive();
                break;
            case "dispose":
                this.dispose();
                break;
        }
    }

    addKeeper() {
        this.keeper = Global.assets['glbs'][`keeper`]['asset'].scene;
        this.scene.add(this.keeper);
        this.keeper.rotation.y = Math.PI;
        this.keeper.position.set(-1, 0, -0.6);


        this.colliderRJ = Global.assets['glbs'][`collider_right_jump`]['asset'].scene;
        this.scene.add(this.colliderRJ);
        this.colliderRJ.rotation.y = Math.PI;
        this.colliderRJ.position.set(-1, 0, -0.6);

        this.colliderLJ = Global.assets['glbs'][`collider_left_jump`]['asset'].scene;
        this.scene.add(this.colliderLJ);
        this.colliderLJ.rotation.y = Math.PI;
        this.colliderLJ.position.set(-1, 0, -0.6);




        this.colliderLJ.visible = false;
        this.colliderRJ.visible = false;

        this.keeper.userData = {
            canCheckIntersects: true,
            itemType: "keeper"
        };
        this.colliderLJ.userData = {
            canCheckIntersects: true,
            itemType: "keeper"
        };
        this.colliderRJ.userData = {
            canCheckIntersects: true,
            itemType: "keeper"
        };

        this.colliderLJ.traverse((child) => {
            if (!child.material) return false;
            child.material.transparent = true;
            child.material.opacity = 0;
        });
        this.colliderRJ.traverse((child) => {
            if (!child.material) return false;
            child.material.transparent = true;
            child.material.opacity = 0;
        });

        this.keeper.traverse((child) => {
            if (!child.material) return false;
            child.material.envMap = Global.envMap;
            child.material.envMapIntensity = 2;
            child.material.side = THREE.DoubleSide
        });


        this.mixer = new THREE.AnimationMixer(this.keeper);
        this.mixer2 = new THREE.AnimationMixer(this.colliderRJ);
        this.mixer3 = new THREE.AnimationMixer(this.colliderLJ);
        this.keeperIdle = THREE.AnimationClip.findByName(Global.assets['glbs'][`keeper`]['asset']['animations'], 'goal_keeper_idel');
        this.idleAnimation = this.mixer.clipAction(this.keeperIdle);

        this.keeperDiveRight = THREE.AnimationClip.findByName(Global.assets['glbs'][`keeper`]['asset']['animations'], 'goal_keeper_ryt_save');
        this.rightJumpAnimation = this.mixer.clipAction(this.keeperDiveRight);

        this.keeperDiveRight2 = THREE.AnimationClip.findByName(Global.assets['glbs'][`collider_right_jump`]['asset']['animations'], 'colliderAction');
        this.rightJumpAnimation2 = this.mixer2.clipAction(this.keeperDiveRight2);



        this.keeperDiveLeft = THREE.AnimationClip.findByName(Global.assets['glbs'][`keeper`]['asset']['animations'], 'goal_keeper_left_save');
        this.leftJumpAnimation = this.mixer.clipAction(this.keeperDiveLeft);

        this.keeperDiveLeft2 = THREE.AnimationClip.findByName(Global.assets['glbs'][`collider_left_jump`]['asset']['animations'], 'colliderAction');
        this.leftJumpAnimation2 = this.mixer3.clipAction(this.keeperDiveLeft2);

        this.keeperDefend = THREE.AnimationClip.findByName(Global.assets['glbs'][`block`]['asset']['animations'], 'block.');
        this.defendAnimation = this.mixer.clipAction(this.keeperDefend);


        this.keeperSlideLeft = THREE.AnimationClip.findByName(Global.assets['glbs'][`keeper`]['asset']['animations'], 'side_step_left');
        this.slideLeftAnimation = this.mixer.clipAction(this.keeperSlideLeft)

        this.keeperSlideRight = THREE.AnimationClip.findByName(Global.assets['glbs'][`keeper`]['asset']['animations'], 'side_step_ryt');
        this.slideRightAnimation = this.mixer.clipAction(this.keeperSlideRight)


        this.keeperHappy = THREE.AnimationClip.findByName(Global.assets['glbs'][`keeper`]['asset']['animations'], 'celebration_2');
        this.happyAnimation = this.mixer.clipAction(this.keeperHappy)

        this.keeperUnhappy = THREE.AnimationClip.findByName(Global.assets['glbs'][`keeper`]['asset']['animations'], 'unhappy_1');
        this.unhappyAnimation = this.mixer.clipAction(this.keeperUnhappy)

        this.defendAnimation.setLoop(THREE.LoopOnce, 1);
        this.defendAnimation.clampWhenFinished = true;

        this.leftJumpAnimation.setLoop(THREE.LoopRepeat, 1);
        this.leftJumpAnimation.clampWhenFinished = true;
        this.leftJumpAnimation2.setLoop(THREE.LoopRepeat, 1);
        this.leftJumpAnimation2.clampWhenFinished = true;

        this.rightJumpAnimation.setLoop(THREE.LoopRepeat, 1);
        this.rightJumpAnimation.clampWhenFinished = true;
        this.rightJumpAnimation2.setLoop(THREE.LoopRepeat, 1);
        this.rightJumpAnimation2.clampWhenFinished = true;


        this.happyAnimation.setLoop(THREE.LoopRepeat, 2);
        this.happyAnimation.clampWhenFinished = true;

        this.mixer.addEventListener('finished', (e) => {
            if (e.action === this.defendAnimation) {
                this.showHappy();
            }
            if (e.action === this.happyAnimation) {
                this.playIdle();
            }

            if (
                ((e.action === this.rightJumpAnimation) ||
                    (e.action === this.leftJumpAnimation)) /* && this.shootStatus!=null */
            ) {
                this.isJumpInProgress = false;

                this.keeper.visible = false;
                this.colliderLJ.visible = false;
                this.colliderRJ.visible = false;

                if (this.shootStatus === "goal") this.showUnhappy();
                if (this.shootStatus !== "goal") this.showHappy();
                this.keeper.position.copy(this.lastPosition)
                this.keeper.position.y = 0;

                this.colliderRJ.position.copy(this.lastPosition)
                this.colliderRJ.position.y = 0;

                this.colliderLJ.position.copy(this.lastPosition)
                this.colliderLJ.position.y = 0;

                //this.
                setTimeout(() => {
                    this.keeper.visible = true;
                }, 0)
            }
        });

        //


        // Add bounding box helper
    }

    stopAll(discardKey) {

        discardKey !== "idle" && this.idleAnimation.stop();
        discardKey !== "right_jump" && this.rightJumpAnimation.stop();
        discardKey !== "right_jump" && this.rightJumpAnimation2.stop();
        discardKey !== "defend" && this.defendAnimation.stop();
        discardKey !== "left_jump" && this.leftJumpAnimation.stop();
        discardKey !== "left_jump" && this.leftJumpAnimation2.stop();
        discardKey !== "slide_left" && this.slideLeftAnimation.stop();
        discardKey !== "slide_right" && this.slideRightAnimation.stop();
        discardKey !== "happy" && this.happyAnimation.stop();
        discardKey !== "unhappy" && this.unhappyAnimation.stop();
    }
    showHappy() {
        if (this.isJumpInProgress) return false;
        this.happyAnimation.play()
        this.stopAll("happy");
    }
    checkIfCanDive() {

        const canJump = (true /* Math.random()<0.8 */ ) && Global.shootDirection !== null;
        if (!canJump) return false;

        this.stopCover();
        setTimeout(() => {
            this.isJumpInProgress = true;
            this[`playJump${Global.shootDirection}`]();
        }, Math.random() * 750+Global.shootCnt*100)
    }
    showUnhappy() {
        this.shootStatus = "goal";
        if (this.isJumpInProgress) return false;
        this.stopCover();
        this.unhappyAnimation.play()
        this.stopAll("unhappy");
    }


    faceToBall(data) {
        // this.keeper.position.set(-1, 0, -0.6);
        this.shootStatus = null;
        this.stopCover();

        this.keeper.position.set(-1, 0, -0.6);
        this.keeper.lookAt(data.position);

        this.colliderRJ.position.set(-1, 0, -0.6);
        this.colliderRJ.lookAt(data.position);

        this.colliderLJ.position.set(-1, 0, -0.6);
        this.colliderLJ.lookAt(data.position);



        //  if(Global.shootCnt>=2){
        //      this.coverPost();
        //  }else{
        //      this.playIdle();
        //  }
        this.playIdle();
        // this.rightJumpAnimation2.play();
    }
    stopCover() {
        this.coverTwn && this.coverTwn.kill();
    }
    coverPost() {
        this.isJumpInProgress = false;
        this.slideLeftAnimation.play();
        this.stopAll("slide_left");
        const converVal = {
            progress: .2
        }
        this.coverDir = 1;
        this.coverTwn = gsap.to(converVal, {
            progress: 0.8,
            duration: 2.0,
            yoyo: true,
            repeat: -1,
            ease: Linear.easeNone,
            onUpdate: function () {
                if (converVal.progress == 0 || converVal.progress == 1) {

                    this.playIdle();
                    this.stopAll("idle");
                }
                this.keeper.position.x = 0.8 - converVal.progress * 4;

                this.colliderRJ.position.x = 0.8 - converVal.progress * 4;
                this.colliderLJ.position.x = 0.8 - converVal.progress * 4;

            }.bind(this),
            onRepeat: function () {
                this.coverDir *= -1;

                if (this.coverDir == -1) {
                    this.slideRightAnimation.play();
                    this.stopAll("slide_right");
                } else {
                    this.slideLeftAnimation.play();
                    this.stopAll("slide_left");
                }
                // This fires when the tween repeats (i.e., starts reversing)
            }.bind(this),
            onReverseComplete: function () {
                // This fires when the tween completes its reverse phase
            }
        });
    }
    defend(data) {
        if (data.itemType !== "keeper") return false;

        this.events.dispatchEvent({
            type: "SOUND_EVENTS",
            message: {
                "event_type": "play_sound",
                data: {
                    'sndKey': 'catch'
                }
            }
        });
        this.shootStatus = "defend";
        if (this.isJumpInProgress) return false;

        this.stopCover();

        this.defendAnimation.play();
        this.stopAll("defend");
    }
    playIdle() {
        this.shootStatus = null;
        this.isJumpInProgress = false;
        this.idleAnimation.play();
        this.stopAll("idle");
    }

    playJumpRight() {

        this.colliderRJ.visible = true;
        this.rightJumpAnimation.play();
        this.rightJumpAnimation2.play();
        this.stopAll("right_jump");
    }

    playJumpLeft() {
        this.colliderLJ.visible = true;
        this.leftJumpAnimation.play();
        this.leftJumpAnimation2.play();
        this.stopAll("left_jump");

    }

    update(data) {
        if (this.mixer) this.mixer.update(Global.delta * 0.013);
        if (this.mixer2) this.mixer2.update(Global.delta * 0.013);
        if (this.mixer3) this.mixer3.update(Global.delta * 0.013);

        if (this.isJumpInProgress) {
            const worldPosition = new THREE.Vector3();
            this.keeper.children[0].children[1].matrixWorld.decompose(worldPosition, new THREE.Quaternion(), new THREE.Vector3());

            this.lastPosition = worldPosition;
        }
        if (this.keeper) {
            Global.keeperX = this.keeper.position.x;
        }

    }

    dispose() {
        // Remove the bounding box helper from the scene
        if (this.boundingBoxHelper) {
            this.scene.remove(this.boundingBoxHelper);
        }
        this.isJumpInProgress = false;
        if (this.keeper) {
            this.keeper.traverse((child) => {
                if (child.isMesh) {
                    if (child.geometry) child.geometry.dispose();
                    if (child.material) {
                        if (Array.isArray(child.material)) {
                            child.material.forEach((material) => material.dispose());
                        } else {
                            child.material.dispose();
                        }
                    }
                }
            });
            this.scene.remove(this.keeper);
            this.keeper = null;
        }
        if (this.colliderRJ) {
            this.colliderRJ.traverse((child) => {
                if (child.isMesh) {
                    if (child.geometry) child.geometry.dispose();
                    if (child.material) {
                        if (Array.isArray(child.material)) {
                            child.material.forEach((material) => material.dispose());
                        } else {
                            child.material.dispose();
                        }
                    }
                }
            });
            this.scene.remove(this.colliderRJ);
            this.colliderRJ = null;

        }
        if (this.colliderLJ) {
            this.colliderLJ.traverse((child) => {
                if (child.isMesh) {
                    if (child.geometry) child.geometry.dispose();
                    if (child.material) {
                        if (Array.isArray(child.material)) {
                            child.material.forEach((material) => material.dispose());
                        } else {
                            child.material.dispose();
                        }
                    }
                }
            });
            this.scene.remove(this.colliderLJ);
            this.colliderLJ = null;
        }
        this.events.removeEventListener("GAMESCENE_EVENTS", this.onEvents);
        this.events.removeEventListener("PLAYER_EVENTS", this.onEvents);
        this.events.removeEventListener("GAME_EVENTS", this.onEvents);
        this.stopAll();
    }
}